// extracted by mini-css-extract-plugin
module.exports = {"root":"PrivacyPolicy_root__2pBDF","lastUpdated":"PrivacyPolicy_lastUpdated__2zDLP"};